import ItensMenu from "./ItensMenu";
import "./Sidebar.css";
import SidebarFooter from "./SidebarFooter";
import SidebarHeader from "./SidebarHeader";
import { useAuth } from "../auth/AuthContext";
import { isSuperAdmin, normalizeAccessType } from "../../utils/accessControl";

const SidebarAdmin = (props) => {
  const { close } = props;
  const { user } = useAuth();
  const showSettings = isSuperAdmin(normalizeAccessType(user?.access_type));

  return (
    <aside className={`sidebar ${close ? "collapsed" : ""}`} id="sidebar">
      <SidebarHeader />

      <nav className="sidebar-menu">
        <ItensMenu
          active={props.dashboardActive}
          icone="📊"
          nome="Dashboard Admin"
          link="/admin/dashboard"
        />
        <ItensMenu
          active={props.usuariosActive}
          icone="👥"
          nome="Usuarios / Licenciados"
          link="/usuarios"
        />
        <ItensMenu
          active={props.comissaoActive}
          icone="💼"
          nome="Lancamentos de comissao"
          link="/lancarcomissao"
        />
        <ItensMenu icone="💰" nome="Pedidos de saque" link="/embreve" />
        <ItensMenu active={props.logsActive} icone="🧾" nome="Logs" link="/logs" />
        {showSettings ? (
          <ItensMenu
            active={props.settingsActive}
            icone="⚙️"
            nome="Configuracoes"
            link="/configuracoes"
          />
        ) : null}
      </nav>

      <SidebarFooter />
    </aside>
  );
};

export default SidebarAdmin;
